const EXERCISES_UI_ANALYTICS_EVENT = {
  EXERCISES_HEADER: 'Exercises LatestExercises Section Header',
  EXERCISES_ITEM: 'Exercises LatestExercises Section Item',
  NO_EQUIPMENT_QUICK_FILTER_APPLIED: 'Exercises No Equipment Filter Applied',
  UPPER_BODY_QUICK_FILTER_APPLIED: 'Exercises Upper Body Filter Applied',
  ABS_QUICK_FILTER_APPLIED: 'Exercises Abs Filter Applied',
  ARMS_QUICK_FILTER_APPLIED: 'Exercises Arms Filter Applied',
  EQUIPMENT_LIST_FILTER_APPLIED: 'Exercises Equipment List Filter Applied',
  EQUIPMENT_LIST_QUICK_FILTER_APPLIED: 'Exercises Equipment List Quick Filter Applied',
  GLUTES_QUICK_FILTER_APPLIED: 'Exercises Glutes Filter Applied',
  LOWER_BODY_QUICK_FILTER_APPLIED: 'Exercises Lower Body Filter Applied',
  WARM_UP_QUICK_FILTER_APPLIED: 'Exercises Warm Up Filter Applied',
  STRETCHING_QUICK_FILTER_APPLIED: 'Exercises Stretching Filter Applied',
  FILTERS_APPLIED: 'Exercises Filters Applied',
  FILTERS_RESET: 'Exercises Filters Reset',
  FILTERS_QUICK_RESET: 'Exercises Filters Quick Reset',
  CLEAR_FILTER: 'Exercises Clear Filters'
}

export default EXERCISES_UI_ANALYTICS_EVENT
